import React from "react";

const Seven_Answer = () => {
  return (
    <>
      <div className="seventh_answer">
        <p>
          The winners of INTERNATIONAL EDUCATION AWARDS are selected by a jury
          comprised of high-profile experts. The various Awards Categories and
          Scope and Assessment of the applications filed by various nominees.
          The Award applications will be assessed by the Edition specific Jury
          for on various parameters including but not limited to Feedback by
          clients through feedback forms and emails, Voting by public at large,
          Feedback by Industry Peers and Professionals collected through
          Personal & Telephonic Interviews and Digital Media Interactions,
          Merits of the claims of Fair Business Practices, CSR activities,
          Eco-friendly developments, Innovations, Benefits to the Society and
          Contribution to the economic growth of the country.
        </p>
      </div>
    </>
  );
};

export default Seven_Answer;
